import {ApiRes} from '../../types/api'
import {apiGet, API_URL} from '../api'
import {IReferrals} from './getReferrals'

export const getReferral = async (exchange?: string): Promise<ApiRes<IReferrals>> => {
    return await apiGet(API_URL, `admin/exchange/referral?exchange=${exchange}`)
}
